import { render, staticRenderFns } from "./UsersGroupsBaseForm.vue?vue&type=template&id=8acaaa50&"
import script from "./UsersGroupsBaseForm.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports